import { LayoutDashboard, ScanLine, ChefHat, ReceiptText, UtensilsCrossed, Boxes,
  Truck, Building2, Calculator, MapPin, Users, BarChart3, Shield, Settings, Gauge, UserCog, Briefcase, Banknote, Inbox, Sunrise, ClipboardList, HeartHandshake } from "lucide-react";
export const NAV = [
  { key: "dashboard", label: "Dashboard", path: "/", icon: LayoutDashboard },
  { key: "manager", label: "Manager Console", path: "/manager", icon: Gauge },
  { key: "inbox", label: "Approval Inbox", path: "/inbox", icon: Inbox, module: "approvals" },
  { key: "pos", label: "POS", path: "/pos", icon: ScanLine },
  { key: "kds", label: "Kitchen (KDS)", path: "/kds", icon: ChefHat },
  { key: "orders", label: "Orders", path: "/orders", icon: ReceiptText },
  { key: "menu", label: "Menu", path: "/menu", icon: UtensilsCrossed },
  { key: "inventory", label: "Inventory", path: "/inventory", icon: Boxes },
  { key: "operations", label: "Operations", path: "/operations", icon: ClipboardList, module: "inventory" },
  { key: "procurement", label: "Procurement", path: "/procurement", icon: Truck },
  { key: "suppliers", label: "Suppliers", path: "/suppliers", icon: Building2 },
  { key: "customers", label: "Customers", path: "/customers", icon: Users },
  { key: "crm", label: "CRM & Loyalty", path: "/crm", icon: HeartHandshake },
  { key: "accounting", label: "Accounting", path: "/accounting", icon: Calculator },
  { key: "hr", label: "HR & Payroll", path: "/hr", icon: UserCog },
  { key: "management", label: "Management", path: "/management", icon: Briefcase, module: "administration" },
  { key: "locations", label: "Locations", path: "/locations", icon: MapPin },
  { key: "tills", label: "TILLs", path: "/tills", icon: Banknote, module: "settings" },
  { key: "reports", label: "Reports", path: "/reports", icon: BarChart3 },
  { key: "digest", label: "Owner Digest", path: "/digest", icon: Sunrise, module: "reports" },
  { key: "administration", label: "Administration", path: "/administration", icon: Shield },
  { key: "settings", label: "Settings", path: "/settings", icon: Settings },
];

const ROLE_LANDING = {
  "Cashier": "/pos",
  "Location Manager / Supervisor": "/pos",
  "Store Manager": "/inventory",
  "Storekeeper": "/inventory",
  "Accounts": "/accounting",
  "HR Manager": "/hr",
  "Guest Experience / CRM": "/crm",
  "Sales and Marketing": "/crm",
};
const MANAGER_ROLES = ["Ownership", "Board/MD", "General Manager", "Group Operations Manager",
  "Area Regional Manager", "Location Manager / Supervisor", "Branch Manager", "Store Manager",
  "Floor Supervisor", "Kitchen Bakery Gelato Supervisor"];
export function canManager(user) {
  if (!user) return false;
  if (user.is_admin) return true;
  return MANAGER_ROLES.includes(user.role?.name);
}
const KEY_BY_PATH = Object.fromEntries(NAV.map((n) => [n.path, n.module || n.key]));
export const navModule = (item) => item?.module || item?.key;

export function landingPath(user) {
  if (!user) return "/login";
  if (user.is_admin) return "/";
  const perms = user.permissions || {};
  const preferred = ROLE_LANDING[user.role?.name];
  if (preferred && (perms[KEY_BY_PATH[preferred]] || []).includes("view")) return preferred;
  if ((perms.dashboard || []).includes("view")) return "/";
  const first = NAV.find((n) => (perms[n.key] || []).includes("view"));
  return first ? first.path : "/";
}
